import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { InteractiveRoomItem } from "$/game/prefabs/InteractiveRoomItem.ts";

export class LampInteractiveObject extends InteractiveRoomItem {
  private tween?: Phaser.Tweens.Tween;
  public isOn: boolean = false;
  private myScene: BasicScene;

  constructor(
    scene: BasicScene,
    private shadowRect: Phaser.GameObjects.Rectangle,
    x: number,
    y: number,
  ) {
    super(scene, x, y, scene.atlas, scene.keys.assets.sprites.items.lamp);
    this.myScene = scene;

    this.setOnClickCallback(() => {
      if (this.tween) {
        this.tween.stop();
      }

      this.isOn = !this.isOn;

      scene.soundManager.playSound(scene.keys.assets.sounds.lightSwitching);

      if (scene.settings.getSetting("isVibrationEnabled")) {
        scene.telegram.twaSDK.hapticFeedback.impactOccurred("medium");
      }

      this.updateShadow();
    });
  }

  /**
   * Обновляет затемнение экрана в зависимости от состояния лампы
   */
  private updateShadow(): void {
    if (this.tween) {
      this.tween.stop();
    }

    const config = this.myScene.global.TUNER_TWA_CONFIG.game.effects.lamp;
    // Когда лампа включена (isOn = true), комната светлая (alpha = 0)
    // Когда лампа выключена (isOn = false), комната темная (alpha = config.shadowAlpha)
    const targetAlpha = this.isOn ? 0 : config.shadowAlpha;
    this.tween = this.myScene.tweens.add({
      targets: this.shadowRect,
      alpha: targetAlpha,
      duration: config.transitionDuration,
      ease: "Linear",
    });
  }

  /**
   * Устанавливает начальное состояние сна (без анимации и звука)
   */
  setInitialSleepState(isSleeping: boolean): void {
    const config = this.myScene.global.TUNER_TWA_CONFIG.game.effects.lamp;
    this.isOn = isSleeping;
    this.shadowRect.setAlpha(isSleeping ? config.shadowAlpha : 0);
  }

  /**
   * Синхронизирует состояние лампы без воспроизведения звука и вибрации
   */
  syncState(isOn: boolean): void {
    if (this.tween) {
      this.tween.stop();
    }

    this.isOn = isOn;
    this.updateShadow();
  }

  override destroy(): void {
    super.destroy();
  }
}
